<script lang="ts">
	import type { HTMLInputAttributes } from "svelte/elements";
	import { Locale, type LocalizedString } from "@core/schema/Locale.js";
	import { emailPattern } from "@core/utils/email.js";
	import { getGlobalTemplateProps } from "../../contexts/getGlobalTemplateProps.js";

	const { ...rest }: HTMLInputAttributes = $props();
	const { tenant } = getGlobalTemplateProps();

	const type = $derived(rest.type ?? "text");
	const customPattern: Partial<Record<NonNullable<HTMLInputAttributes["type"]>, string>> = {
		email: emailPattern,
	};
	const pattern = $derived(rest.pattern ?? customPattern[type]);

	const customValidationMessage: Partial<Record<NonNullable<HTMLInputAttributes["type"]>, LocalizedString>> = {
		email: {
			[Locale.cs]: "Zadali jste neplatnou e-mailovou adresu",
			[Locale.en]: "You have entered an invalid email address",
			[Locale.sk]: "Zadali ste neplatnú e-mailovú adresu",
		},
		url: {
			[Locale.cs]: "URL adresa (včetně https://)",
			[Locale.en]: "URL address (including https://)",
			[Locale.sk]: "URL adresa (vrátane https://)",
		},
	};

	function validate({ currentTarget }: Event & { currentTarget: EventTarget & HTMLInputElement }): void {
		currentTarget.setCustomValidity("");

		if (currentTarget.validity.valid) {
			currentTarget.setCustomValidity("");
		} else {
			const customMessage = customValidationMessage[type]?.[tenant.locale];
			if (customMessage) {
				currentTarget.setCustomValidity(customMessage);
			}
		}
	}
</script>

<input
	{...rest}
	class={[
		"min-w-0 border border-[#D7D7D7] rounded-[.25rem] [&:user-invalid]:border-red-300 transition-[outline,text,border] duration-300 focus:border-zms-blue focus:[&:user-invalid]:outline-zms-blue outline-transparent outline-1 outline outline-offset-1 font-semibold md:text-[1.125rem]/[1.2] p-2 md:p-7 focus:text-zms-optical-black text-[#595959]",
		{
			"min-h-[3.125rem]": !["radio", "checkbox"].includes(type),
		},
		rest.class,
	]}
	{pattern}
	oninput={(event: Event & { currentTarget: EventTarget & HTMLInputElement }): void => {
		validate(event);
		rest.oninput?.(event);
	}}
	oninvalid={(event: Event & { currentTarget: EventTarget & HTMLInputElement }): void => {
		validate(event);
		rest.oninvalid?.(event);
	}}
/>
